module.exports = "/images/start-sell-online.svg?d716d9b5636b09df54d67a8a3cee7a8e";